import dayjs from 'dayjs';
import dayjsPluginUTC from 'dayjs-plugin-utc';

dayjs.extend(dayjsPluginUTC);

const formatTabLabel = (pickupCode, dropoffCode, pickupDateTime, returnDateTime) =>
  `${pickupCode} - ${dropoffCode} (${dayjs(pickupDateTime).format('M/D/YY')} - ${dayjs(
    returnDateTime,
  ).format('M/D/YY')})`;

export default formatTabLabel;
